import React, { ReactElement } from 'react';
import { Tooltip, Typography, Box } from '@mui/material';

interface TPOTooltipProps {
  title: string;
  content: string | null;
  children: ReactElement;
}

const TPOTooltip = (props: TPOTooltipProps) => {
  return (
    <Tooltip
      arrow
      enterDelay={500}
      placement="right"
      tabIndex={-1}
      title={
        <React.Fragment>
          <Typography color="inherit" sx={{ fontWeight: 'bold', fontSize: '14px', marginBottom: props.content ? '4px' : '0' }}>
            {props.title}
          </Typography>
          {props.content && (
            <Typography variant="body2" sx={{ whiteSpace: 'pre-line', fontSize: '12px' }}>
              {props.content}
            </Typography>
          )}
        </React.Fragment>
      }
    >
      <Box className="tpo-tooltip-trigger" sx={{ display: 'inline-flex', cursor: 'pointer' }}>
        {props.children}
      </Box>
    </Tooltip>
  );
};

export default TPOTooltip;
